/**
 * Gallery images section
 */

import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { kebabCase } from "lodash"
import "../styles/gallery.css"

const Gallery = ({ props }) => {
  return (
    <section
      className="section container m-section"
      key={props.includeInStickyMenu?.menuTitle || "Gallery"}
      id={`${kebabCase(props.includeInStickyMenu?.menuTitle) || ""}`}
    >

          <div className="gallery gap-8 lg:w-8/12 mx-auto overflow-visible relative">
            {props.images?.map((img, index) => {
              const image = {
                src: img?.localFile ? getImage(img?.localFile) : null,
                alt: img?.altText || ``,
              }
              return (
                <span
                  className="block mb-8 gallery-img transform overflow-visible relative"
                  key={image.alt}
                  data-sal="fade-in"
                  data-sal-delay={index * 100 + 300}
                >
                  {image?.src && (
                    <GatsbyImage image={image.src} alt={image.alt} />
                  )}
                </span>
              )
            })}
          </div>
      
    </section>
  )
}

export default Gallery
